<script lang="ts">
  import type { FooterRowStoryblok } from '~/component-types-sb';
  import { FooterRow } from '@agapi/ui/footer';
  import { StoryblokComponent, storyblokEditable } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';

  interface Props {
    blok: FooterRowStoryblok;
  }

  const { blok }: Props = $props();

  const gridStyles = css.raw({
    display: blok.displayType === 'grid' ? 'grid' : 'flex',
    gridTemplateColumns: {
      base: blok.columns_mobile ? `repeat(var(--mobileCols), 1fr)` : 'auto',
      sm: blok.columns_tablet ? `repeat(var(--tabletCols), 1fr)` : 'auto',
      lg: blok.columns_desktop ? `repeat(var(--desktopCols), 1fr)` : 'auto',
    },
    alignItems: blok.align || 'stretch',
    gap: '4',
    rowGap: '6',
  });

  const staticStyles = `
    --mobileCols: ${blok.columns_mobile};
    --tabletCols: ${blok.columns_tablet};
    --desktopCols: ${blok.columns_desktop};
  `
  // console.log('footer-row', blok);

</script>

<FooterRow use={[[storyblokEditable, blok]]} css={gridStyles} style={staticStyles}>
  {#each blok.content || [] as nestedBlok}
    <StoryblokComponent blok={nestedBlok} />
  {/each}
</FooterRow>
